import { dataWoman } from 'dls-icons-data'
import { createIcon } from '../common'

const IconWoman = /*#__PURE__*/createIcon(dataWoman)
export default IconWoman
